import { IApplicationState } from '../../../../../../types/types';
import { TCommentId } from '../../../../../../store/model/card/types/IComment';

export const getReplyCommentId = (state: IApplicationState): TCommentId => {
    return state.comments.replyCommentId;
}
